<template>
  <public-layout>
    <section class="hero lvl3">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="product-title">
                Fun Learning Team
              </p>
              <p class="product-subtitle">
                Your partners in FUN to lifelong learning adventures!
              </p>
              <p class="product-description">
                We are Tuka, Maco, Waaba and Soca, on a lifelong Fun Learning journey ourselves.
                 We embrace diversity, live on curiosity and love to explore.
                  Sometimes we get into trouble, but we learn from our mistakes and bounce right back with each other’s help. Join us and let’s discover the joy of learning together!
              </p>
              <p class="product-cta">
                <router-link class="button button-large button-secondary" :to="{ name: 'about-us' }">Go Back</router-link>
              </p>
            </div>
            <div class="column is-narrow">
              <img class="product-image" src="/static/img/assets/team.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="hero section-services" :class="{ 'has-top-gray-hero': !moreInfo }">
      <div class="hero-body">
        <div class="container">
          <div class="columns has-text-centered">
            <div class="column">
              <p class="subsection-title">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/C_Ko4vrqqDY" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section is-left-aligned">
      <div class="container">
          <div class="columns is-vcentered has-text-centered">
          <div class="column">
            <div class="content">

              <h2 class="section-title">Meet the Team</h2>
              <br>
              <div class="columns">
                <div class="column is-3">
                  <img src="static/img/team/tuka.jpg" alt="Tuka">
                  <h3>Tuka</h3>
                  <h4>Brave superwoman</h4>
                  <p>I rule in sports and never back away from an adventure. Sometimes competitiveness gets the best of me,
                     but I always try to stand up for others and make the world a better place.
                    <br><br/><i>"If there’s a will, there’s a way."</i>
                  </p>
                </div>
                <div class="column is-3">
                  <img src="static/img/team/maco.jpg" alt="Maco">
                  <h3>Maco</h3>
                  <h4>Ingenious smartypants</h4>
                  <p>I ace in technology and build the coolest gadgets from scratch. Sometimes, I can get annoyed when others don’t keep up with me.
                     I always try to use my knowledge to find answers to problems.
                    <br><br/><i>"If you can imagine it, you can make it!"</i>
                  </p>
                </div>
                <div class="column is-3">
                  <img src="static/img/team/waaba.jpg" alt="Waaba">
                  <h3>Waaba</h3>
                  <h4>Kind and caring fairy</h4>
                  <p>I fly calmly into conflicts, and spread peace like magical pixie dust with the power of my mind. I can be a little too starry-eyed, but my dream is to help everyone to be happy.
                    <br><br/><i>"Life is better if we are all happy."</i>
                  </p>
                </div>
                <div class="column is-3">
                  <img src="static/img/team/soca.jpg" alt="Soca">
                  <h3>Soca</h3>
                  <h4>Adorable warrior</h4>
                  <p>I can speak any language, and even talk to plants and animals. I could be over-worried sometimes, but I’m a great friend to all living things and always try to keep them safe.
                    <br/><br/><br/><i>"Life is better if we are together."</i>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import SectionContact from '@/components/SectionContact'
import Button from '@/components/Button'

export default {
  name: 'kinderpage',

  components: {
    PublicLayout,
    SectionContact,
    Button
  },

  created () {},

  data () {
    return {}
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/FLTeamPage.vue